import Model from "./model.js";
import GameScene from "./gamescene.js";
import LevelScene from "./levelscene.js";
import SimplePreloader from "./simple-preloader.js";

var config = {
	type: Phaser.AUTO,
	width: 500,
	height: 500,
	parent: "game",
	mode: Phaser.Scale.FIT,
	autoCenter: Phaser.Scale.CENTER_BOTH
};

var game = new Phaser.Game(config);
const model = new Model();
game.globals = { model };
game.scene.add("simplePreloader", new SimplePreloader("levelScene"));
game.scene.add("gameScene", new GameScene());
game.scene.add("levelScene", new LevelScene());
game.scene.start("simplePreloader");